import {SyntheticEvent} from 'react';
import {TrackingContextValue} from '@homeaway/react-event-tracking';

import {getFilterId} from './filters';

export const GENERIC_EVENT = 'generic.event';

export const triggerEdapEventForCheckbox = (
    event: SyntheticEvent<HTMLInputElement>,
    tracking: TrackingContextValue
) => {
    const filterId = getFilterId(event);
    const eventaction = `filter ${
        event.currentTarget.checked ? '' : 'un'
    }selected`;

    if (event.currentTarget.checked) {
        if (filterId) {
            tracking.trigger(GENERIC_EVENT, {
                eventaction,
                eventlabel: filterId,
            });

            const groupId = event.currentTarget.dataset.groupid;
            tracking.trigger(GENERIC_EVENT, {
                eventaction,
                eventlabel: `${groupId}:${filterId}`,
            });
        }
    } else {
        tracking.trigger(GENERIC_EVENT, {eventaction});
    }
};
